export default __webpack_public_path__ + "static/nmc-code-of-conduct-1-0-16444125b862965d9fc1c00e54c35d55.pdf";